module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/common-module/components/header-search-bar/header-search-bar.component.scss
// module id = ./src/app/modules/common-module/components/header-search-bar/header-search-bar.component.scss
// module chunks = 9